import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CartStore } from '@apps/mtjr/customers/app/cart/cart.store';
import {
  IonAvatar,
  IonButton,
  IonContent,
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterLink,
  IonSkeletonText,
  IonSplitPane,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonText,
} from '@ionic/angular/standalone';
import { AuthStateStore } from '@libs/core/lib/auth/auth-state.store';
import { VxCurrencyPipe } from '@libs/core/lib/pipes/mtjr-currency.pipe';
import { QuarterFloorPipe } from '@libs/core/lib/pipes/quarter-floor.pipe';
import { AppAlerts } from '@libs/core/lib/utils/app-alerts';
import { ThemeToggleComponent } from '@libs/core/lib/utils/theme/theme-toggle.component';
import {} from '@libs/core/lib/utils/theme/theme.store';
import { LanguageSwitcherComponent } from '@libs/mtjr/shared/i18n/language-switcher.component';
import { NotificationsStore } from '@libs/mtjr/shared/notifications/notifications.store';
import { UserStore } from '@libs/mtjr/shared/user/user.store';
import { WalletStore } from '@libs/mtjr/shared/wallet/wallet.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mac-tabs',
  imports: [
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
    RouterLink,
    IonMenu,
    IonContent,
    IonSplitPane,
    IonList,
    RouterLink,
    IonRouterLink,
    IonItem,
    RouterLinkActive,
    IonLabel,
    IonAvatar,
    IonText,
    IonFooter,
    ThemeToggleComponent,
    IonSkeletonText,
    IonButton,
    TranslatePipe,
    LanguageSwitcherComponent,
    VxCurrencyPipe,
    QuarterFloorPipe,
    IonMenuToggle,
  ],
  template: `
    <ion-content>
      <ion-split-pane when="(min-width: 1280px)" contentId="main">
        <ion-menu contentId="main" style="--side-max-width: 330px; --background" swipeGesture="false">
          <ion-menu-toggle auto-hide="false">
            <div class="flex flex-col pt-safe-t">
              <div class="!mx-2 flex items-center rounded-md px-3 py-1">
                <img src="https://nbg1.your-objectstorage.com/mtjr/logo.svg" height="40" class="" alt="" />
                <ion-text class="mx-4 my-3">
                  <p class="text-primary text-2xl font-bold">متجر</p>
                  <p class="text-surface/20 text-md mt-0.5">{{ 'COMMON.ONLINE_SHOPPING_PLATFORM' | translate }}</p>
                </ion-text>
              </div>
              <div class="bg-medium/10 h-[2px]"></div>
              @if (authStore.isAuthenticated()) {
                <ion-item lines="none ms-2 " routerLink="wallet" routerLinkActive="text-primary">
                  <ion-icon slot="start" name="wallet" />
                  <ion-label>
                    <span>{{ 'WALLET.BALANCE' | translate }}</span>
                  </ion-label>
                  <ion-text class="text-success ms-au">
                    {{ walletStore.walletBalance() | quarterFloor | vxCurrency }}
                  </ion-text>
                </ion-item>
                <div class="bg-medium/10 h-[2px]"></div>
              }
              <ion-list class="bg-transparent *:ms-2">
                <ion-item lines="none" routerLink="landing" routerLinkActive="text-primary">
                  <ion-label>{{ 'COMMON.HOME' | translate }}</ion-label>
                  <ion-icon slot="start" name="home"></ion-icon>
                </ion-item>
                @if (authStore.isAuthenticated()) {
                  <ion-item lines="none" routerLink="wishlist" class="hidden xl:block" routerLinkActive="text-primary">
                    <ion-label>{{ 'USER.WISHLIST' | translate }}</ion-label>
                    <ion-icon slot="start" name="heart"></ion-icon>
                  </ion-item>
                  <ion-item routerLink="/orders" lines="none" class="hidden xl:block" routerLinkActive="text-primary">
                    <ion-label>{{ 'USER.MY_ORDERS' | translate }}</ion-label>
                    <ion-icon slot="start" name="orders"></ion-icon>
                  </ion-item>
                  <ion-item routerLink="account/addresses" lines="none" routerLinkActive="text-primary">
                    <ion-label>{{ 'USER.MY_ADDRESSES' | translate }}</ion-label>
                    <ion-icon slot="start" name="location"></ion-icon>
                  </ion-item>
                }
                <ion-item routerLink="cart" lines="none" routerLinkActive="text-primary">
                  <ion-label>{{ 'COMMON.CART' | translate }}</ion-label>
                  <ion-icon slot="start" name="cart"></ion-icon>
                  @if (cartStore.totalCount() > 0) {
                    <div
                      slot="end"
                      class="bg-danger flex h-4 min-w-4 items-center justify-center rounded-full p-1 text-center text-xs text-white"
                    >
                      <span>{{ cartStore.totalCount() }}</span>
                    </div>
                  }
                </ion-item>
                @if (authStore.isAuthenticated()) {
                  <ion-item lines="none" routerLink="settings" routerLinkActive="text-primary">
                    <ion-label>{{ 'SETTINGS.TITLE' | translate }}</ion-label>
                    <ion-icon slot="start" name="settings" />
                  </ion-item>
                }
                <ion-item lines="none" (click)="themeSwitch.toggleTheme(); $event.stopPropagation()">
                  <ion-label>
                    {{ 'COMMON.APPEARANCE' | translate }}
                  </ion-label>
                  <ion-icon slot="start" name="theme" />
                  <mtjr-theme-toggle slot="end" #themeSwitch [disabled]="true" />
                </ion-item>
              </ion-list>
            </div>
          </ion-menu-toggle>

          <ion-footer class="bg-light shadow-sm">
            <ion-item>
              <ion-text>
                {{ 'COMMON.LANGUAGE' | translate }}
              </ion-text>
              <mtjr-language-switcher slot="end" />
            </ion-item>
            <ion-item class="ios-pb my-2 !ms-0 native:pb-4" lines="none">
              <ion-avatar slot="start">
                <img [src]="userStore.profileImage()" referrerPolicy="no-referrer" />
              </ion-avatar>
              @if (!userStore.isStateInitial()) {
                <ion-label class="flex flex-col">
                  @if (userStore.name(); as name) {
                    <p class="!text-dark !m-0">{{ name }}</p>
                  } @else if (userStore.loggedInUserLoading()) {
                    <ion-skeleton-text animated="true" class="mt-2 rounded-md" style="width: 30%" />
                  }
                  @if (userStore.userName(); as email) {
                    <p class="text-light !m-0 truncate text-start">{{ email }}</p>
                  } @else {
                    <ion-skeleton-text animated="true" class="my-1 rounded-md" style="width: 50%" />
                  }
                </ion-label>
                <ion-button fill="clear" slot="end" size="large" mode="md" (click)="signOut()">
                  <ion-icon slot="icon-only" name="logout" />
                </ion-button>
              } @else {
                <ion-label>{{ 'USER.GUEST' | translate }}</ion-label>
                <ion-button fill="clear" slot="end" class="capitalize" (click)="signIn()">
                  {{ 'USER.LOGIN' | translate }}
                </ion-button>
              }
            </ion-item>
          </ion-footer>
        </ion-menu>
        <ion-tabs class="ion-page" id="main">
          <ion-tab-bar slot="bottom" class="xl:hidden">
            <ion-tab-button tab="landing">
              <ion-icon name="home"></ion-icon>
              <ion-label>{{ 'COMMON.HOME' | translate }}</ion-label>
            </ion-tab-button>
            <ion-tab-button tab="cart" class="relative">
              <ion-icon name="cart"></ion-icon>
              <ion-label>{{ 'COMMON.CART' | translate }}</ion-label>
              @if (cartStore.totalCount() > 0) {
                <div
                  class="bg-danger p absolute start-[50%] top-1 flex h-4 min-w-4 items-center justify-center rounded-full text-center text-xs text-white"
                >
                  <span style="font-family: sans-serif;">{{ cartStore.totalCount() }}</span>
                </div>
              }
            </ion-tab-button>
            @if (authStore.isAuthenticated()) {
              <ion-tab-button tab="wishlist">
                <ion-icon name="heart"></ion-icon>
                <ion-label>{{ 'USER.WISHLIST' | translate }}</ion-label>
              </ion-tab-button>

              <ion-tab-button tab="orders">
                <ion-icon name="orders"></ion-icon>
                <ion-label>{{ 'ORDERS.ORDERS' | translate }}</ion-label>
              </ion-tab-button>
            }
          </ion-tab-bar>
        </ion-tabs>
      </ion-split-pane>
    </ion-content>
  `,
})
export class TabsPage {
  authStore = inject(AuthStateStore);
  userStore = inject(UserStore);
  cartStore = inject(CartStore);
  alerts = inject(AppAlerts);
  walletStore = inject(WalletStore);
  notificationsStore = inject(NotificationsStore);

  async signIn() {
    this.authStore.signIn();
  }

  async signOut() {
    const confirm = await this.alerts.yesNoAlertTR({
      header: 'USER.SIGN_OUT',
      message: 'USER.CONFIRM_SIGN_OUT',
    });
    if (confirm) {
      await this.notificationsStore.removeFcmToken();
      await this.authStore.signOut();
    }
  }
}
